import * as String from "../../commons/string";
import Apollo3DView from "../../components/apollo3d/Apollo3DView";

/**
 * Apollo 자율주행 모니터링 페이지 — 3D(R3F) 전용.
 * 데이터·렌더·컨트롤·텔레메트리는 Apollo3DView가 자체 포함(useApolloFrame 공유 파이프라인).
 */
const PageAutonomousMonitoring = () => {
    return (
        <div className="pageWrapper">
            <div style={{ margin: "16px 0 12px", fontWeight: 700, fontSize: "1.15rem" }}>
                {String.autonomousMonitoring}
            </div>
            <Apollo3DView />
        </div>
    );
};

export default PageAutonomousMonitoring;
